import React from 'react'
import { Typography, Modal, Button, Row, Col, Popconfirm } from 'antd'
import IframeFile from '../IframeFile'
import { checkLinkURL } from '../../../utils/auth'
import {
    LoadingOutlined,
    DeleteOutlined,
    FilePdfOutlined,
    EyeOutlined
} from '@ant-design/icons';


const { Text, Title } = Typography
class ModalshowAllImage extends React.PureComponent {

    state = {
		dataImages: [],
        removeKey: [],
        showModalFile : false
	}

    onDelect = async (keys, name, fileIdBase64 = null) =>{
        const { dataArrayId, destroyArrayDataImages } = this.props
        const { removeKey } = this.state

        document.getElementById('block_show_'+keys).remove();

        let countBlockFile = document.getElementsByClassName('block_show_file');
        if(countBlockFile.length == 0){
            await this.setState({
                showModalFile: false
            })
        }

        destroyArrayDataImages(dataArrayId, name, fileIdBase64)
    }

    hideModal = () =>{
        const { hideModal, destroyArrayDataImages, dataArrayId } = this.props
        const { removeKey } = this.state

        
        console.log(dataArrayId.sort)
        // destroyArrayDataImages(dataArrayId, removeKey)
        // hideModal()
    }

    onClickToNewTab = (keys, typeFile) =>{
        // var win = window.open();
        var win = window.open();
        if(typeFile == 'pdf'){
            var output = document.getElementById('show_iframe_'+keys);
            win.document.write('<iframe src="' + output.src  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        }else{
            var output = document.getElementById('show_images_'+keys);
            console.log('output',output.src)
            win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + output.src  + '" style="max-width:100%;height:auto"/></div>');
        }
    }

    onViewImages = (file) =>{
        var win = window.open();
        win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="'+file+'" style="max-width:100%; height:auto"/></div>');
    }

    checkShowImage = (check, values, keys) =>{
        const { statusForm } = this.props

        if(check == 'database'){
            return  <div  align="center" className="block-show-image-modal" style={{ width:"400px"}}>
                        <img src={values.fileBase64.includes("base64,") ? values.fileBase64 : checkLinkURL()+values.fileBase64} style={{  height:"200px"}} id={"show_images_"+keys}/>
                        <a 
                            onClick={ () => this.onViewImages(values.fileBase64.includes("base64,") ? values.fileBase64 : checkLinkURL()+values.fileBase64) } 
                            className={`icons-show-images  ${statusForm == 'MOREINFO' || statusForm == 'DRAFT' ? '' : 'icons-show-image-hide'}`}
                        >
                            <EyeOutlined className="ic-custom"/>
                        </a>
                        {
                           statusForm == 'MOREINFO' || 
                           statusForm == 'DRAFT'
                           ?
                                <Popconfirm 
                                    placement="top" 
                                    title={"ต้องการที่จะลบรูปภาพนี้"} 
                                    onConfirm={() => this.onDelect(keys, values.name, values.idFile)} 
                                    okText="ตกลง" 
                                    cancelText="ปิด"
                                >
                                    <span className="icons-delect-images" style={{ cursor:"pointer" }}>
                                        <DeleteOutlined className="ic-custom" />
                                    </span>
                                </Popconfirm>
                            :
                            ''
                        }
                    </div>
        }else{
            return <div  align="center" className="block-show-image-modal" style={{ width:"400px"}}>
                        <img style={{  height:"200px"}} id={"show_images_"+keys}/>
                        <a onClick={()=> this.onClickToNewTab(keys, "img")} className="icons-show-images">
                            <EyeOutlined className="ic-custom"/>
                        </a>
                        <a onClick={()=> this.onDelect(keys, values.name)} className="icons-delect-images">
                            <DeleteOutlined className="ic-custom" />
                        </a>
                    </div>
        }
    }

    checkShowPDF = (check, values, keys) =>{
        const { statusForm } = this.props

        if(check == 'database'){
            // return  <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
            //             {/* <IframeFile typeFile={values.fileMimeType}  file={values.fileIdBase64} showPdfFild={true}/> */}
            //             <a href={checkLinkURL()+values.fileBase64} className="color-white" target="_blank" >
            //                   <FilePdfOutlined /><br></br>
            //                   ดูไฟล์ PDF
            //                </a>
            return  <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
            {/* <IframeFile typeFile={values.fileMimeType}  file={values.fileIdBase64} showPdfFild={true}/> */}
            <iframe id={'show_iframe_'+keys} src={values.fileBase64.includes("base64,") ? values.fileBase64 : checkLinkURL()+values.fileBase64} style={{ opacity:"0", height:"0" }} style={{ display:"none" }}></iframe>
            {/* <a href={values.fileBase64.includes("base64,") ? values.fileBase64 : checkLinkURL()+values.fileBase64} className="color-white" target="_blank" > */}
            <a onClick={()=> this.onClickToNewTab(keys, "pdf")} className="color-white">
                  <FilePdfOutlined /><br></br>
                  ดูไฟล์ PDF
               </a>
                        {
                           statusForm == 'MOREINFO' || 
                           statusForm == 'DRAFT'
                           ?
                            <Popconfirm 
                                    placement="top" 
                                    title={"ต้องการที่จะลบไฟล์นี้"} 
                                    onConfirm={() => this.onDelect(keys, values.name, values.idFile)} 
                                    okText="ตกลง" 
                                    cancelText="ปิด"
                                >
                                    <span className="icons-delect-images" style={{ cursor:"pointer" }}>
                                        <DeleteOutlined className="ic-custom" />
                                    </span>
                                </Popconfirm>
                            :
                            ''
                        }
                        
                    </div>
        }else{
            return  <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                        <iframe id={'show_iframe_'+keys} style={{ opacity:"0", height:"0" }} style={{ display:"none" }}></iframe>
                        <a onClick={()=> this.onClickToNewTab(keys, "pdf")} className="color-white">
                            <FilePdfOutlined /><br></br>
                            ดูไฟล์ PDF
                        </a><br></br> 
                        <a onClick={()=> this.onDelect(keys, values.name)} className="icons-delect-images">
                            <DeleteOutlined className="ic-custom" />
                        </a>
                    </div>
        }
    }

    bodyHtmlShowImage = (dataFile) => {
        console.log('adfadataFile',dataFile)
        return <>
                <Row  gutter={16} type="flex" justify="left" align="top" >
                    {
                        dataFile.map((values, keys) =>{
                            if(values){
                                return  <>
                                            <Col span={8} className="mb-3 block_show_file" id={"block_show_"+keys} style={{ display:"block"}}>
                                                {
                                                    values.fileIdBase64 ? 
                                                        values.fileMimeType !== "application/pdf" ? 
                                                            <>  
                                                                { this.checkShowImage('database', values, keys ) }
                                                            </>
                                                        :
                                                            <>
                                                                { this.checkShowPDF('database', values, keys ) }
                                                            </>

                                                    :
                                                        <>
                                                            {
                                                                values.type !== "application/pdf" ?
                                                                    this.checkShowImage('fileUploads', values, keys )
                                                                :
                                                                    this.checkShowPDF('fileUploads', values, keys )
                                                            }
                                                        </>
                                                }
                                            </Col>
                                        </>
                            }
                        })
                    }
                </Row>
            </>
    }

    modalShowFileCreate = (dataFile) =>{
        if(dataFile.length !== 0){
            return dataFile.map((values, keys) =>{
                if(values){
                    if(!values.fileIdBase64){
                        var url = URL.createObjectURL(values)
                        const reader = new FileReader();
                        let linkNewTab = null
                        if(values.type !== "application/pdf"){
                            reader.readAsDataURL(values)
                            reader.onloadend = async (e) => {
                                var dataURL = reader.result;
                                var output = document.getElementById('show_images_'+keys);
                                // output.src = dataURL;
                                if(output){
                                    output.src = dataURL;
                                }
                                // linkNewTab = dataURL
                                // await this.setState({
                                //     linkNewTab: dataURL
                                // })
                            };
                        }else{
                            reader.readAsDataURL(values)
                            reader.onloadend = async (e) => {
                                var dataURL = reader.result;
                                var output = document.getElementById('show_iframe_'+keys);
                                console.log('output',output)
                                if(output){
                                    output.src = dataURL;
                                }
                                // output.href = dataURL;
                                // linkNewTab = dataURL
                                // await this.setState({
                                //     linkNewTab: dataURL
                                // })
                                // return <iframe href={dataURL} style={{ width:"100%", height:"500px" }}></iframe>
                            };
                        }
                    }
                }
            })
        }
    }

	async componentDidMount() {
        const { title, subtitle, showModal, data, hideModal } = this.props
        await this.setState({
            dataImages: data,
            showModal: showModal
        })
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
		const { data } = this.props
        const { dataImages, showModal } = this.state

	}

	render() {
        const { title, subtitle, data, showModal, hideModal, imageDatabase, statusForm = false } = this.props
        const { showModalFile } = this.state

        console.log('asdfasfdasffas',data)
		return (
			<>
				<Modal
                    destroyOnClose={true}
                    maskClosable={false}
					visible={ showModal}
					title={title}
					// title="ไฟล์อัปโหลดรูปใบเสร็จ"
					onOk={ hideModal }
					onCancel={ hideModal }
					width={800}
					footer={null}
                    // maskClosable={true}
                     // closable={false}
                >
                        { this.bodyHtmlShowImage(data) }
                        { this.modalShowFileCreate(data) }
				</Modal>
			</>
		)
	}
}

export default ModalshowAllImage